import * as $ from 'jquery';
import { inArray } from '../../../../../services/arrays';
import { getCurrencySymbol } from './';
import { CurrencyCode, ICurrency } from './currency-storage';

let visibleOptions: CurrencyCode[] = ['EUR', 'GBP', 'USD'];

let currencySwitcher: HTMLSelectElement | null;
let $currencySwitcher: JQuery<HTMLSelectElement>;

export const getCurrencySwitcher = () => $currencySwitcher;

export function optionVisible(code: CurrencyCode): boolean {
    return inArray(code, visibleOptions);
}

export function clearOptions(): void {
    if (!currencySwitcher) return;
    currencySwitcher.innerHTML = '';
    visibleOptions = [];
}

export function addOption(currency: ICurrency): void {
    const symbol = getCurrencySymbol(currency.code);
    const suffix = symbol && symbol !== currency.code ? ` (${symbol})` : '';

    $currencySwitcher.append(`<option value="${currency.code}">${currency.code}${suffix}</option>`);
    visibleOptions.push(currency.code);
}

export function selectOption(currency: CurrencyCode): void {
    if (!currencySwitcher) return;
    currencySwitcher.value = currency;
}

export function loadCurrencyView(): void {
    currencySwitcher = document.getElementById('gete-currency-switcher') as HTMLSelectElement;
    $currencySwitcher = $(currencySwitcher) as typeof $currencySwitcher;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/modules/bundle/currencies/currency-view.ts